<template>
  <CRow class="pl-5 pr-5 mb-5 mt-4">
    <CCol sm="12 mb-5">
      <h2 class="askTitle">{{ $t('managePlan.features-table.title') }}</h2>
    </CCol>
    <CCol class="mainBoxFeat" sm="3">
      <PayPeriodToggle class="mx-auto" :text="$t('managePlan.features-table.payment-period-toggle.text')" style="max-width: 200px" />
    </CCol>
    <CCol v-for="pn in planFeatures" :key="pn.planId" class="mainBoxFeat">
      <div class="blockTitle mt-2">{{ handlePlanNameCard(pn.planName) }}</div>
      <template>
        <div v-if="pn.planName == planNames.payAsYouGo" class="h-30 mt-2"></div>
        <template v-if="pn.monthPrice">
          <div v-if="paymentPeriod == 1" class="blockSubTitle mt-2">{{ pn.monthPrice }} € / {{ $t('managePlan.features-table.month') }}</div>
          <div v-if="paymentPeriod == 3" class="blockSubTitle mt-2">{{ pn.monthPrice }} € / {{ $t('managePlan.features-table.month') }}</div>
          <div v-if="paymentPeriod == 3" class="blockSaveInfo">
            {{ $t('managePlan.features-table.you-pay') }} {{ pn.annualWithoutDiscount }} € / {{ $t('managePlan.features-table.year') }}
          </div>
        </template>
        <div v-if="pn.planName != 'Free'">
          <!-- adicionei um segundo botão de get Started, pois precisava diferenciar quando isAvaiable é verdadeiro ou falso  -->
          <CButton
            v-if="!pn.currentPlan && !pn.isAvaiable"
            @click="selectPlan(2, pn)"
            :disabled="!pn.isAvaiable || !isOrganizationApproved"
            class="mt-5 outline"
            :class="{
              btnRecommendedPlan: pn.isRecommended && pn.visible,
              btnOptionPlan: pn.isAvaiable && !pn.isRecommended,
              btnCurrentPlan: !pn.isAvaiable,
            }"
            v-c-tooltip="{ content: $t('card.plan.details.tooltip.downgrade'), placement: 'bottom' }"
          >
            {{ $t('card.plan.details.btn.started') }}
          </CButton>
          <CButton
            v-if="!pn.currentPlan && pn.isAvaiable"
            @click="selectPlan(2, pn)"
            :disabled="!pn.isAvaiable || !isOrganizationApproved"
            class="mt-5 outline"
            :class="{
              btnRecommendedPlan: pn.isRecommended && pn.visible,
              btnOptionPlan: pn.isAvaiable && !pn.isRecommended,
              btnCurrentPlan: !pn.isAvaiable,
            }"
          >
            {{ $t('card.plan.details.btn.started') }}
          </CButton>
          <CButton v-if="pn.currentPlan && currentPlan.planTiers.maxAudienceRecipients >= maxAudience" class="mt-5 btnCurrentPlan" disabled>
            {{ $t('managePlan.features-table.button.current-plan') }}
          </CButton>
          <CButton
            v-if="pn.currentPlan && currentPlan.planTiers.maxAudienceRecipients < maxAudience"
            @click="selectPlan(2, pn)"
            :disabled="!isOrganizationApproved"
            class="mt-5 outline"
            :class="{ btnRecommendedPlan: pn.isRecommended, btnOptionPlan: !pn.currentPlan && !pn.isRecommended }"
          >
            {{ $t('card.plan.details.btn.started') }}
          </CButton>
        </div>
      </template>
    </CCol>
    <CCol sm="12" class="colMainFeat">
      <CRow class="rowFeat" v-for="feat in tableFeatures" :key="feat.feature">
        <CCol sm="3" class="elementFeat">
          <strong>{{ feat.feature }}</strong>
        </CCol>
        <CCol class="elementFeat" v-for="(vl, index) in feat.values" :key="`${'vl'}-${index}`">
          <span v-if="vl != 'check' && vl != 'noCheck'">{{ vl }}</span>
          <CIcon v-if="vl == 'check'" class="checkMark mr-2" name="checkMark" :height="15" viewBox="0 0 32 32" />
          <CIcon v-if="vl == 'noCheck'" class="refused mr-2" name="cross" :height="15" viewBox="0 0 32 32" />
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import PayPeriodToggle from './PayPeriodToggle.vue'
import { PLAN_FEATURES } from '@/views/plansSubscriptions/constants'
import { planType } from '@/utils/enumsUtils.js'

const planTierEnum = {
  FREE: 0, // Caso seja FREE
  MOUNTH: 1,
  YEAR: 3,
}

const planNames = {
  free: 'Free',
  starter: 'Starter',
  professional: 'Professional',
  business: 'Business',
  payAsYouGo: 'PayAsYouGo',
}

export default {
  name: 'PlansFeaturesTable',
  components: {
    PayPeriodToggle,
  },
  props: {
    plans: {
      type: Array,
      default: null,
    },
    plansCatalog: {
      type: Array,
      default: null,
    },
    currentPlan: {
      type: Object,
      default: null,
    },
    isOrganizationApproved: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      plansNamesToShow: [planNames.starter, planNames.professional, planNames.business, planNames.payAsYouGo],
      planFeatures: [
        {
          blockTitle: 'planSubscriptions.free.everythingYouGet',
          available: PLAN_FEATURES.free.available,
          notAvailable: PLAN_FEATURES.free.notAvailable,
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: false,
          isFree: false,
          isRecommended: false,
          planName: planNames.free,
          planId: null,
          selectedTierId: null,
          visible: true,
        },
        {
          blockTitle: 'planSubscriptions.starter.everythingYouGet',
          available: PLAN_FEATURES.starter.available,
          notAvailable: PLAN_FEATURES.starter.notAvailable,
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: false,
          isFree: false,
          isRecommended: false,
          planName: planNames.starter,
          planId: null,
          selectedTierId: null,
          visible: false,
        },
        {
          blockTitle: 'planSubscriptions.professional.everythingYouGet',
          available: PLAN_FEATURES.professional.available,
          notAvailable: PLAN_FEATURES.professional.notAvailable,
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: false,
          isFree: false,
          isRecommended: true,
          planName: planNames.professional,
          planId: null,
          selectedTierId: null,
          visible: false,
        },
        {
          blockTitle: 'planSubscriptions.payAsYouGo.everythingYouGet',
          available: PLAN_FEATURES.payAsYouGo.available,
          notAvailable: PLAN_FEATURES.payAsYouGo.notAvailable,
          monthPrice: null,
          annualWithoutDiscount: null,
          annualPrice: null,
          currentPlan: false,
          isFree: false,
          isRecommended: false,
          planName: planNames.payAsYouGo,
          planId: null,
          selectedTierId: null,
          visible: false,
        },
      ],
      isFree: true,
      planNames,
    }
  },
  beforeMount() {
    this.updatePlanOptions()
  },
  mounted() {},
  methods: {
    selectPlan(step, selectedPlan) {
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedPlanName', data: selectedPlan.planName })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedPlanId', data: selectedPlan.planId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedTierId', data: selectedPlan.selectedTierId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'periodPlanTierPriceId', data: selectedPlan.periodPlanTierPriceId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'mount', data: selectedPlan.monthPrice })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedPlan', data: selectedPlan })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'maxStep', data: step })

      if (planType(selectedPlan.planType) === planType(5)) {
        this.$router.push({
          name: 'manage-balance',
          query: {
            selectedPlanId: selectedPlan.planId,
          },
        })

        return
      }

      this.$store.dispatch('backOffice/steps/setCurrentStep', step)
    },
    updateCurrentPlan() {
      var price = this.getCurrentPlanPriceByPlanIdAndMaxAudience()
      var annualWithoutDiscount = price * 12
      annualWithoutDiscount = annualWithoutDiscount.toFixed(2)
      var isFree = this.currentPlan.name == 'Free' ? true : false
      this.isFree = this.currentPlan.name == 'Free' ? true : false
      var itemIndex = this.planFeatures.findIndex((x) => x.planName == this.currentPlan.name)

      let newValue = {
        ...this.planFeatures[itemIndex],
        planId: this.currentPlan.id,
        monthPrice: price,
        annualWithoutDiscount: annualWithoutDiscount,
        annualPrice: annualWithoutDiscount,
        currentPlan: true,
        visible: true,
        isFree: isFree,
      }

      this.$set(this.planFeatures, itemIndex, newValue)
    },

    updatePlanOptions() {
      let planName = this.currentPlan.name
      let currentRecipients = this.currentPlan.planTiers?.maxAudienceRecipients || 25 // Caso seja o plano free
      let currentPeriod = this.currentPlan.planTiers?.periodPlanTierPrice.paymentPeriod || 0 // Caso seja o plano free

      this.plansNamesToShow.forEach((name) => {
        let fullPrice = this.getPriceInPlanCatalog(name)
        let selectedTier = this.getTierInPlanCatalog(name)

        let mounthPrice = null
        let anualPrice = null

        this.isFree = false // TODO: ajustar checagem de plano

        let itemIndex = this.planFeatures.findIndex((x) => x.planName == name)

        /*
         * ? Essa propriedade valida se o plano está disponível
         * ? caso não haja preço ou tier, o plano não estará disponível
         */
        let isAvaiable = fullPrice != null && selectedTier != null

        const plan = this.getPlanByName(name)

        const isPlanTypePayAsYouGo = plan?.planType ? planType(plan.planType) === planType(5) : false

        let isCurrentPlan

        if (!isPlanTypePayAsYouGo) {
          if (!isAvaiable) {
            fullPrice = this.getPriceByPlanNameAndMaxAudience(name)
            selectedTier = this.getPriceIdByPlanNameAndMaxAudience(name)
            mounthPrice = selectedTier.planPeriod == planTierEnum.MOUNTH ? fullPrice : fullPrice / 12
            anualPrice = selectedTier.planPeriod == planTierEnum.YEAR ? fullPrice : null
          } else {
            mounthPrice = selectedTier.planPeriod == planTierEnum.MOUNTH ? fullPrice : fullPrice / 12
            anualPrice = selectedTier.planPeriod == planTierEnum.YEAR ? fullPrice : null
          }
          isCurrentPlan =
            selectedTier.maxAudienceRecipients == currentRecipients &&
            selectedTier?.planPeriod == currentPeriod &&
            planName?.toLowerCase() == name.toLowerCase()
        } else {
          isCurrentPlan = planName?.toLowerCase() == name.toLowerCase()
          isAvaiable = planType(this.currentPlan.planType) !== planType(2)
          const paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod

          const matchedTier = plan.planTiers.find((tier) => tier.periodPlanTierPrice.paymentPeriod == paymentPeriod)
          selectedTier = {
            tierId: matchedTier.periodPlanTierPrice.planTierId,
            periodPlanTierPriceId: matchedTier?.periodPlanTierPrice.id,
          }
        }

        let newValue = {
          ...this.planFeatures[itemIndex],
          planId: plan.id,
          monthPrice: mounthPrice?.toFixed(1),
          annualWithoutDiscount: anualPrice?.toFixed(2),
          annualPrice: anualPrice?.toFixed(2),
          currentPlan: isCurrentPlan,
          isFree: this.isFree,
          selectedTierId: selectedTier?.tierId,
          periodPlanTierPriceId: selectedTier?.periodPlanTierPriceId,
          visible: true,
          isAvaiable,
          planType: plan.planType,
        }

        this.$set(this.planFeatures, itemIndex, newValue)
      })
    },

    getPlanByName(planName) {
      let plan = this.plans.find((item) => item.name === planName)
      return plan
    },

    getPriceIdByPlanNameAndMaxAudience(planName) {
      if (planName == 'Free') {
        return null
      }
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let plan = this.plans.find((item) => item.name === planName)
      let planTier = plan.planTiers.find(
        (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
      )
      if (typeof planTier != 'undefined') {
        return {
          maxAudienceRecipients: planTier.maxAudienceRecipients,
          planPeriod: planTier.periodPlanTierPrice.paymentPeriod,
          tierId: planTier.periodPlanTierPrice.planTierId,
          periodPlanTierPriceId: planTier.periodPlanTierPrice.id,
        }
      }
      return
    },

    getPriceInPlanCatalog(planName) {
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let plan = this.plansCatalog.find((item) => item.name === planName)

      if (plan) {
        let planTier = plan.planTiers.find(
          (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
        )

        if (typeof planTier != 'undefined') {
          return planTier.periodPlanTierPrice.price
        }
        return null
      } else return null
    },

    getTierInPlanCatalog(planName) {
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let plan = this.plansCatalog.find((item) => item.name === planName)

      if (plan) {
        let planTier = plan.planTiers.find(
          (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
        )
        if (typeof planTier != 'undefined') {
          return {
            maxAudienceRecipients: planTier.maxAudienceRecipients,
            planPeriod: planTier.periodPlanTierPrice.paymentPeriod,
            tierId: planTier.periodPlanTierPrice.planTierId,
            periodPlanTierPriceId: planTier.periodPlanTierPrice.id,
          }
        }
        return null
      } else return null
    },

    getPriceByPlanNameAndMaxAudience(planName) {
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let plan = this.plans.find((item) => item.name === planName)
      let planTier = plan.planTiers.find(
        (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
      )
      if (typeof planTier != 'undefined') {
        return planTier.periodPlanTierPrice.price
      }
      return
    },

    getCurrentPlanPriceByPlanIdAndMaxAudience() {
      let paymentPeriod = this.$store.state.backOffice.steps.paymentPeriod
      let currentPlanDetails = this.plans.find((it) => it.name == this.currentPlan.name)
      if (this.currentPlan.name == 'Free') {
        return null
      }
      let planTier = currentPlanDetails.planTiers.find(
        (it) => it.maxAudienceRecipients == this.maxAudience && it.periodPlanTierPrice.paymentPeriod == paymentPeriod,
      )
      if (typeof planTier != 'undefined') {
        return planTier.periodPlanTierPrice.price
      }
      return
    },

    applyDiscount(value) {
      let discount = value * 0.1
      let newValue = value - discount
      return newValue.toFixed(1)
    },

    handlePlanNameCard(planName) {
      if (planName == this.planNames.payAsYouGo) return 'Pay As You Go'
      return planName
    },
  },
  watch: {
    maxAudience() {
      this.updatePlanOptions()
    },
    paymentPeriod() {
      this.updatePlanOptions()
    },
  },
  computed: {
    tableFeatures() {
      return [
        {
          feature: this.$t('planSubscriptions.table-features.platformUsers'),
          values: [
            `${this.$t('planSubscriptions.free.platformUsers')}`,
            `${this.$t('planSubscriptions.starter.platformUsers')}`,
            `${this.$t('planSubscriptions.professional.platformUsers')}`,
            `${this.$t('planSubscriptions.payAsYouGo.platformUsers')}`,
          ],
        },
        {
          feature: this.$t('planSubscriptions.table-features.flexibleImport'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          feature: this.$t('planSubscriptions.table-features.audienceSegmentation'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          feature: this.$t('planSubscriptions.table-features.integratedCustomerProfile'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          feature: this.$t('planSubscriptions.table-features.multichannelCampaignEditor'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          feature: this.$t('planSubscriptions.table-features.campaignTemplate'),
          values: [
            this.$t('planSubscriptions.free.campaignTemplates'),
            this.$t('planSubscriptions.starter.campaignTemplates'),
            this.$t('planSubscriptions.professional.campaignTemplates'),
            this.$t('planSubscriptions.payAsYouGo.campaignTemplates'),
          ],
        },
        {
          feature: this.$t('planSubscriptions.table-features.templatesPremium'),
          values: ['noCheck', 'noCheck', 'check', 'noCheck'],
        },
        {
          feature: this.$t('planSubscriptions.table-features.htmlTemplateImport'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          feature: this.$t('planSubscriptions.table-features.campaignDashboardAndStatistics'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          feature: this.$t('planSubscriptions.table-features.customerSupport'),
          values: [
            this.$t('planSubscriptions.free.chatEmailSupport'),
            this.$t('planSubscriptions.starter.chatEmailSupport'),
            this.$t('planSubscriptions.professional.chatEmailSupport'),
            this.$t('planSubscriptions.payAsYouGo.chatEmailSupport'),
          ],
        },
      ]
    },
    paymentPeriod() {
      return this.$store.state.backOffice.steps.paymentPeriod
    },

    maxAudience() {
      if (this.$store.state.backOffice.steps.maxAudience == 0) {
        return 500
      }

      /*if (this.currentPlan.planTiers.maxAudienceRecipients > this.$store.state.backOffice.steps.maxAudience) {
        return this.currentPlan.planTiers.maxAudienceRecipients
      }*/

      return this.$store.state.backOffice.steps.maxAudience
    },
  },
}
</script>

<style lang="scss" scoped>
.h-30 {
  height: 30px;
}
</style>

<style lang="scss">
.blockPlanDetails {
  background-color: #fff;
  min-height: 580px;
  max-width: 330px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 20px 25px;
}

.blockPlanRecommendedDetails {
  background-color: #fff;
  min-height: 580px;
  max-width: 330px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 20px 25px;
  border: 2px solid #403266;
  position: relative;
}

.recommended {
  background-color: #403266;
  width: 45%;
  height: 28px;
  position: absolute;
  right: -2px;
  top: -1px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  border-top-right-radius: 10px 10px;
  border-bottom-left-radius: 10px 10px;
  line-height: 2.3;
}

.blockTitle {
  color: #343a40;
  font-size: 22px;
  font-weight: bold;
}

.blockSubTitle {
  color: #343a40;
  font-size: 27px;
  font-weight: bold;
  line-height: 1.1;
}

.blockSaveInfo {
  color: #868e96;
  font-size: 16px;
  line-height: 1.4;
}

.btnCurrentPlan {
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #adb5bd;
  color: #adb5bd;
  width: 100%;
  height: 40px;
}

.btnOptionPlan {
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #403266;
  color: #403266;
  width: 100%;
  height: 40px;
}

.btnRecommendedPlan {
  background-color: #403266;
  border-radius: 5px;
  color: #fff;
  width: 100%;
  height: 40px;
  border: 1px solid #403266;
}

.blockFeatureTitle {
  color: #343a40;
  font-size: 13px;
  font-weight: 700;
}

.blockFeatures {
  font-size: 13px;
}

.checkMark {
  color: #403266;
}

.refused {
  color: #868e96;
}

.colMainFeat {
  padding: 0px;
}

.rowFeat {
  margin-right: 0px;
  margin-left: 0px;
}

.elementFeat {
  border: 1px solid #dee2e6;
  padding: 15px 25px;
  font-size: 14px;
  color: #343a40;
}

.mainBoxFeat {
  border: 1px solid #dee2e6;
  min-height: 230px;
  padding-top: 10px;
}

.check {
  color: #403266;
}

.refused {
  color: #868e96;
}
</style>
